export default {
  title: "مدیریت Policy",
};
